<template>
    <v-ons-page>
        <ons-list>
            <ons-list-header>Settings</ons-list-header>
            <ons-list-item v-if="enabled">
                <div class="center">
                    Enable push notifications
                </div>
                <div class="right">
                    <ons-switch :checked="active" :disabled="loading" v-on:change="updateDeviceToken"></ons-switch>
                </div>
            </ons-list-item>
            <ons-list-item v-else>
                <div class="center">
                    <i>Push notifications not available</i>
                </div>
            </ons-list-item>
        </ons-list>
        <div class="container">
            <h4>
                {{ heading }}
            </h4>
            <p v-if="loading"><i>Loading...</i></p>
        </div>
        <v-ons-row>
            <v-ons-col>
                <v-ons-card v-for="not in notificationData" :key="not.id" class="card--notification">
                    <div class="title">
                        <a v-on:click="() => deleteNotification(not)"
                            class="close">
                            <ons-icon icon="md-close" class="ons-icon zmdi zmdi-close"></ons-icon>
                        </a>
                        {{ _.get(not, 'attributes.title' )}}
                    </div>
                    <div class="content justify content--notification" v-html="_.get(not, 'attributes.content')"></div>
                </v-ons-card>
            </v-ons-col>
        </v-ons-row>

    </v-ons-page>
</template>

<script>
import Utils from './mixins/Utils'
import PushNotification from './mixins/PushNotification'
import Module from './mixins/Module'

export default {
    data () {
        return {
            active: false,
            loading: true,
            enabled: true,
        }
    },

    created() {
        this.$emit('init', {
            name: 'notifications',
            title: 'Notifications',
            showMenu: true,
        })

        if (!this.customer.content.id) {
            return this.$router.push('login')
        }

        let device_uuid = _.get(window, 'device.uuid');
        if (device_uuid) {
            this.device.getInitialData(`/my/device/${device_uuid}`, {
                token: this.getToken(),
            }).then(res => {
                this.active = _.get(res, 'attributes.active', false);
                this.$forceUpdate();
            })
        } else {
            this.enabled = false;
        }

        this.notifications.getData({
            query: {
                open: true,
            }
        }).finally(() => {
            this.loading = false;
            this.$forceUpdate();
        })
    },

    mixins: [
        Utils,
        PushNotification,
        Module('customer'),
        Module('device'),
        Module('notifications'),
    ],

    computed: {
        notificationData() {
            return _.get(this.notifications, 'content.data', []);
        },
        heading() {
            if(_.get(this.notificationData, 'length') > 0){

                return `You have ${_.get(this.notificationData, 'length')} notification${_.get(this.notificationData, 'length') > 1 ? 's' : '' }`;
            }
            return 'No new notifications';
        }
    },

    methods: {
        deleteNotification(not) {
            return this.notifications.updateBatch({
                data: [{ id: not.id, $detach: true }],
            }).then(() => {
                this.notification_push({
                    type: 'success',
                    message: 'Message has been removed',
                })
            })
        },

        updateDeviceToken(e) {
            let active = e.target.checked;

            if (_.get(this.device, 'content.id')) {
                return this.device.updateData({
                    data: {
                        active,
                    }
                })
                    .then((res) => this.active = _.get(res, 'attributes.active', false))
                    .catch(() => this.active = false)
            } else {
                return this.registerDevice(this.customer.content.id)
                    .then((result) => this.active = Boolean(result))
                    .catch(() => this.active = false)
            }
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
    text-align: center;
    padding: 20px 0 0 0;
}
.list-header{
    background-color: var(--second-highlight-color);
}
.justify {
    color: black;
    margin: 16px;
}
.close{
    margin-left: 10px;
    float: right;
}
.card__title{
    text-transform: none;
    padding: 14px 18px;
    font-size: 16px;
    margin-top: 4px;
}
.card__content{
    margin: 0 18px;
    padding: 0 0 16px 0;
}
.zmdi-close{
    color: rgba(138, 138, 143, 0.87);
    margin-top: -4px;
}
</style>



// WEBPACK FOOTER //
// src/components/NotificationPage.vue